<template>
  <InputWrapper
    v-slot="{ ariaProps, inputClasses, inputId }"
    :input-id="id"
    :label="t('common.valueOfGoods')"
    :label-help-text="t('orders.valueOfGoodsInformation')"
    :warning="warning"
    label-icon="pi pi-info-circle"
  >
    <InputMoney
      :id="inputId"
      v-model="effectiveValueOfGoods"
      v-bind="ariaProps"
      :class="inputClasses"
      :disabled="disabled"
      class="flex-grow-0 w-4"
      :placeholder="t('common.valueOfGoods')"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { Money } from '@rygen/rygen-ui/model';

import { useValueOfGoods } from '@/composables';
import { LineItem } from '@/model';

import InputMoney from '@rygen/rygen-ui/components/form/InputMoney.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const orderValue = defineModel('orderValue', {
  type: Object as PropType<Money | undefined>,
  default: () => undefined,
});

const lineItems = defineModel('lineItems', {
  type: Array as PropType<LineItem[]>,
  default: () => [],
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
});
const { id, disabled } = toRefs(props);

const { t } = useI18n();

const { effectiveValueOfGoods, wasClearedByDirectEdit } = useValueOfGoods(
  orderValue,
  lineItems,
);

const warning = computed(() =>
  wasClearedByDirectEdit.value ? t('orders.valueOfGoodsWarning') : '',
);
</script>
